import React from "react";
import { Link } from "@quintype/components";
import { object, array, string, number, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { flatten } from "lodash";

import CollectionTitleWithArrow from "../../../atoms/CollectionTitleWithArrow";
import Organism from "../Organism";

import { getSlug, getCollectionName } from "../../../../components/utils/utils";
import { MICROSITES_OLD_URLS } from "../../../../../server/helpers/constants";

import "./row.m.css";

const Row = ({
  collection,
  sections,
  domainSlug,
  cdnImage,
  colNumber,
  showSubHeading,
  columnColor0,
  columnColor1,
  columnColor2,
  columnColor3,
  numberOfStories,
  totalCollection = 1,
}) => {
  const stories =
    collection.items &&
    collection.items.length > 0 &&
    collection.items.filter((item) => item.type === "story").slice(0, numberOfStories);

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], true);

  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const collectionName = getCollectionName(collection, navigateToTitle);

  const isPhoto = get(collection, ["metadata", "cover-image", "cover-image-s3-key"], null);
  const collectionPhoto = isPhoto !== null && "https://" + cdnImage + "/" + isPhoto;

  const genCollectionSlug = () => {
    const flattenedUrls = flatten(MICROSITES_OLD_URLS);
    const slugIndex = flattenedUrls.indexOf(collectionSlug);
    return slugIndex >= 0 ? flattenedUrls[slugIndex + 1] : collectionSlug;
  };

  const styles = {
    bgColor: {
      background:
        (colNumber === 0
          ? columnColor0
          : colNumber === 1
          ? columnColor1
          : colNumber === 2
          ? columnColor2
          : columnColor3) + "1a",
      borderBottom:
        colNumber === 0 && columnColor0
          ? "1px solid " + columnColor0
          : colNumber === 1 && columnColor1
          ? "1px solid " + columnColor1
          : colNumber === 2 && columnColor2
          ? "1px solid " + columnColor2
          : colNumber === 3 && columnColor3
          ? "1px solid " + columnColor3
          : "1px solid #e2e2e2",
    },
    fontColor: {
      color:
        colNumber === 0
          ? columnColor0
          : colNumber === 1
          ? columnColor1
          : colNumber === 2
          ? columnColor2
          : colNumber === 3
          ? columnColor2
          : "",
    },
    dotColor: {
      color:
        (colNumber === 0
          ? columnColor0
          : colNumber === 1
          ? columnColor1
          : colNumber === 2
          ? columnColor2
          : colNumber === 3
          ? columnColor2
          : "#cccccc") + "4d",
    },
  };
  return (
    <div
      style={styles.bgColor}
      styleName={`${styles.bgColor.background !== "1a" ? "with-bg-color" : "with-no-bg-color"}`}
    >
      {showCollectionName ? (
        <CollectionTitleWithArrow
          collectionSlug={collectionSlug}
          collectionName={collectionName}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
          styles={styles}
        />
      ) : collectionPhoto ? (
        <div className="banner-photo" styleName="banner-photo">
          <Link href={genCollectionSlug()}>
            <img src={collectionPhoto} alt={collectionName} />
          </Link>
        </div>
      ) : null}
      {stories && stories.length > 0 && (
        <Organism
          stories={stories}
          colNumber={colNumber}
          styles={styles}
          showSubHeading={showSubHeading}
          collectionPhoto={collectionPhoto}
          collectionName={collectionName}
          collectionSlug={genCollectionSlug()}
          totalCollection={totalCollection}
        />
      )}
    </div>
  );
};

Row.propTypes = {
  collection: object.isRequired,
  sections: array,
  domainSlug: string,
  cdnImage: string,
  colNumber: number,
  showSubHeading: bool,
  columnColor0: string,
  columnColor1: string,
  columnColor2: string,
  columnColor3: string,
  numberOfStories: number,
  totalCollection: number,
};

const mapStateToProps = (state) => ({
  cdnImage: get(state, ["qt", "config", "publisher-attributes", "cdn_image"], null),
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(Row);
